  export function getCost(values) {
    if (values?.costOfGoods) return values.costOfGoods
    if (values?.insurance?.id === 0) {
      if (values?.consignmentType?.id === 0) {
        if (values?.contentType?.id === 0) return pocketPrice
        if (values?.contentType?.id === 1) return packagePrice
      }
      if (values?.consignmentType?.id === 1) return packagePrice
    }
    return values?.value
  }


  export const pocketPrice=59999999
  export const packagePrice=99999999

  